import React from "react"
import "./style.scss"
import careerImage from "../../images/career.jpg"
import Table from "react-bootstrap/Table"

const Careers = props => {
  const sectionData = {
    title: "Dream \nWithout fear",
    subtitle: "Join Our Team for a better future",
    careers: [
      {
        index: 1,
        job_role: "Python Developer",
        location: "Bangalore, Delhi",
        date: "8 AUG 2021",
        status: false,
      },
      {
        index: 2,
        job_role: "Data Engineer",
        location: "Bangalore, Delhi",
        date: "8 AUG 2021",
        status: false,
      },
      {
        index: 3,
        job_role: "React Developer",
        location: "Bangalore, Delhi",
        date: "8 AUG 2021",
        status: false,
      },
      {
        index: 4,
        job_role: "Mobile App Developer",
        location: "Bangalore, Delhi",
        date: "8 AUG 2021",
        status: false,
      },
      {
        index: 5,
        job_role: "Python Developer",
        location: "London",
        date: "9 APR 2021",
        status: false,
      },
      {
        index: 6,
        job_role: "React Developer",
        location: "New York",
        date: "9 APR 2021",
        status: false,
      },
      {
        index: 7,
        job_role: "Content Writer",
        location: "London",
        date: "9 APR 2021",
        status: false,
      },
      {
        index: 8,
        job_role: "Digital Marketing Specialist",
        location: "New York",
        date: "9 APR 2021",
        status: false,
      },
      {
        index: 9,
        job_role: "Power BI Specialist",
        location: "New York",
        date: "9 APR 2021",
        status: false,
      },
      {
        index: 10,
        job_role: "Senior Front End Developer - React Js",
        location: "Coimbatore",
        date: "6 JUL 2021",
        status: false,
      },
      {
        index: 11,
        job_role: "Software Testing - Lead",
        location: "Coimbatore",
        date: "6 JUL 2021",
        status: false,
      },
      {
        index: 12,
        job_role: "Senior Devops Engineer",
        location: "Coimbatore",
        date: "6 JUL 2021",
        status: false,
      },
      {
        index: 13,
        job_role: "Architect - Lead",
        location: "Coimbatore",
        date: "6 JUL 2021",
        status: false,
      },
      {
        index: 14,
        job_role: "ML Engineers",
        location: "Coimbatore",
        date: "6 JUL 2021",
        status: false,
      },
      {
        index: 15,
        job_role: "Motion Graphic Designer",
        location: "Coimbatore",
        date: "13 AUG 2021",
        status: false,
      },
    ],
  }
  const { title, subtitle, careers } = sectionData
  return (
    <div className="careers_page">
      <div className="top_area">
        <div>
          <h1 className="title">{title}</h1>
          <p className="sub_title">{subtitle}</p>
        </div>
        <div className="image_container">
          <img alt="career" src={careerImage} />
        </div>
      </div>
      <div className="listings">
        <div className="desktop">
          {/* <div className="header">
            <p>SNO</p>
            <p>JOB ROLE</p>
            <p>LOCATION</p>
            <p className="status">STATUS</p>
          </div>
          {careers.map((career, index) => {
            return (
              <div className="career_item" key={index}>
                <p>{career.index}</p>
                <p>{career.job_role}</p>
                <p>{career.location}</p>
                <button>{!career.status ? "Apply" : "Applied"}</button>
              </div>
            )
          })} */}
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <p>SNO</p>
                </th>
                <th>
                  <p>JOB ROLE</p>
                </th>
                <th>
                  <p>LOCATION</p>
                </th>
                <th className="status">
                  <p>STATUS</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {careers.map((career, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <p>{career.index}</p>
                    </td>
                    <td>
                      <p>{career.job_role}</p>
                    </td>
                    <td>
                      <p>{career.location}</p>
                    </td>
                    <td>
                      <button
                        onClick={() =>
                          (window.location.href = "mailto:careers@datinfi.com")
                        }
                      >
                        {!career.status ? "Apply" : "Applied"}
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
        <div className="mobile">
          {careers &&
            careers.map((career, index) => {
              return (
                <div
                  className="career_item"
                  key={index}
                  onClick={() =>
                    (window.location.href = "mailto:careers@datinfi.com")
                  }
                >
                  <div className="job-info">
                    <h1 className="role">{career.job_role}</h1>
                    <p className="location">{career.location}</p>
                  </div>
                  <hr className="separator" />
                  <div className="date">
                    <p>{career.date}</p>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default Careers
